import { ensureLatAndLng } from "../modules/project";
const initialState = {
  geojson: null,
  projects: [],
};
export default (state = initialState, action) => {
  switch (action.type) {
    case "GEOJSON:REQUEST": {
      return { ...state, geojson: null };
    }
    case "GEOJSON:SUCCESS":
      return { ...state, geojson: action.payload };
    case "GEOJSON:FAILURE":
    case "PROJECT:ALL:FAILURE":
      console.error(action.payload);
      return { ...state, error: action.payload };
    case "REGIONCONTENT:SET":
      return { ...state, regionContent: action.payload };
    case "PROJECT:ALL:SUCCESS":
      const projectsWithLatLong = action.payload
        .filter(row => {
          if (!ensureLatAndLng(row)) {
            return false;
          } else {
            return true;
          }
        });

      return {
        ...state,
        projects: projectsWithLatLong,
      };
    default:
      return state;
  }
};

// Anything that needs all projects calls this
// give it arguments, each one gets called with the whole state
export const selectAllProjects = state => {
  return state.projects;
};

export const selectGeoJSON = state => state.geojson;

export const selectAllRegionContent = state => {
  return state.regionContent;
};


// WEBPACK FOOTER //
// ./src/reducers/data.js